module.exports = __webpack_public_path__ + "img/layout_right_5.1f726aec.png";